import { useLang } from "../lib/i18n";
import { PageHeader } from "../components/ui-vision";

const COMPANY = [
  "COMEC BV",
  "Nom commercial : Vision+",
  "Groot-Molenveldlaan 51 003",
  "1850 Grimbergen",
  "Belgique",
  "Numéro d'entreprise : 0758.412.316",
  "Numéro de TVA : BE 0758.412.316",
  "E-mail : info@vplus.be",
  "Téléphone : 02 588 56 00",
  "Site internet : vplus.be",
];

const COMPANY_NL = [
  "COMEC BV",
  "Handelsnaam: Vision+",
  "Groot-Molenveldlaan 51 003",
  "1850 Grimbergen",
  "België",
  "Ondernemingsnummer: 0758.412.316",
  "Btw-nummer: BE 0758.412.316",
  "E-mail: info@vplus.be",
  "Telefoon: 02 588 56 00",
  "Website: vplus.be",
];

const SECTIONS = {
  fr: [
    {
      h: "Responsabilité",
      p: [
        "Les informations publiées sur ce site sont fournies à titre indicatif et sont susceptibles d'évoluer. Vision+ s'efforce d'en assurer l'exactitude et la mise à jour, sans pouvoir garantir qu'elles soient exemptes d'erreurs ou d'omissions.",
        "Vision+ ne saurait être tenue responsable de l'usage fait de ces informations ni des éventuels dommages résultant de l'accès ou de l'utilisation du site.",
      ],
    },
    {
      h: "Propriété intellectuelle",
      p: [
        "L'ensemble des éléments du site Vision+ — identité visuelle, textes, graphismes, logos, illustrations et autres contenus originaux — est protégé par le droit de la propriété intellectuelle et demeure la propriété de COMEC BV, sauf mention contraire.",
        "Toute reproduction, représentation ou réutilisation, totale ou partielle, sans autorisation préalable écrite, est interdite.",
      ],
    },
    {
      h: "Liens externes",
      p: [
        "Le site peut contenir des liens vers des sites tiers. Vision+ n'exerce aucun contrôle sur ces sites et décline toute responsabilité quant à leur contenu ou à leurs pratiques.",
      ],
    },
  ],
  nl: [
    {
      h: "Aansprakelijkheid",
      p: [
        "De op deze website gepubliceerde informatie wordt ter informatie verstrekt en kan wijzigen. Vision+ streeft naar juistheid en actualisering, zonder te kunnen garanderen dat de informatie vrij is van fouten of weglatingen.",
        "Vision+ kan niet aansprakelijk worden gesteld voor het gebruik van deze informatie, noch voor eventuele schade die voortvloeit uit de toegang tot of het gebruik van de website.",
      ],
    },
    {
      h: "Intellectuele eigendom",
      p: [
        "Alle elementen van de Vision+-website — visuele identiteit, teksten, grafische elementen, logo's, illustraties en andere originele inhoud — worden beschermd door het intellectuele-eigendomsrecht en blijven eigendom van COMEC BV, tenzij anders vermeld.",
        "Elke reproductie, weergave of hergebruik, geheel of gedeeltelijk, zonder voorafgaande schriftelijke toestemming is verboden.",
      ],
    },
    {
      h: "Externe links",
      p: [
        "De website kan links naar websites van derden bevatten. Vision+ heeft geen controle over deze websites en wijst elke aansprakelijkheid voor hun inhoud of praktijken af.",
      ],
    },
  ],
};

export default function MentionsLegales() {
  const { lang } = useLang();
  const isFr = lang !== "nl";
  const company = isFr ? COMPANY : COMPANY_NL;
  const sections = SECTIONS[isFr ? "fr" : "nl"];

  return (
    <div data-testid="mentions-legales">
      <PageHeader
        overline={isFr ? "Informations légales" : "Juridische informatie"}
        title={isFr ? "Mentions légales" : "Wettelijke vermeldingen"}
      />
      <div className="max-w-3xl mx-auto px-6 md:px-12 pb-20 md:pb-28 space-y-12">
        <section>
          <h2 className="font-display text-xl md:text-2xl font-medium tracking-tight mb-4">
            {isFr ? "Éditeur du site" : "Uitgever van de website"}
          </h2>
          <p className="text-white/55 font-light leading-relaxed mb-3">
            {isFr ? "Le présent site est édité par :" : "Deze website wordt uitgegeven door:"}
          </p>
          <ul className="space-y-1.5 text-white/70 font-light">
            {company.map((line, i) => (
              <li key={i}>{line}</li>
            ))}
          </ul>
        </section>

        {sections.map((s) => (
          <section key={s.h}>
            <h2 className="font-display text-xl md:text-2xl font-medium tracking-tight mb-4">{s.h}</h2>
            {s.p.map((para, i) => (
              <p key={i} className="text-white/55 font-light leading-relaxed mb-3 last:mb-0">
                {para}
              </p>
            ))}
          </section>
        ))}
      </div>
    </div>
  );
}
